import React from 'react';
import Navbar from '../components/Internal-nav';  
import ContactBanner from '../components/contact-banner';
import './home.scss';

function ContractorsShowroom() {


  return (
    <div className='configure-page'>
      <header>
        <Navbar />
      </header>
      <div className='inner-banner' style={{ backgroundImage: "url(../assets/contractor-banner.jpg)" }}>
        <div className='banner-content'>
          <h1>Contractor's Showroom</h1>
        </div>
      </div>
      <div className='container'>
        <div className='flooring-info'>
        <p>BC Surface Supply has created the "Contractors Showroom" as a tool for our construction partners to utilize in helping their clients 
          with material selections for their projects. Our showroom features cabinet and countertop mock ups to help the clients visualize their design options. 
          We also have a large inventory of granite and quartz slabs on hand for clients to choose from, as well as, numerous samples of countertop options 
          available for order.
</p>
<p>The showroom is available by appointment only, please call us at (260) 321-3092 to schedule an appointment.</p>
      </div>
      </div>
      <ContactBanner></ContactBanner>
    </div>
  );
}

export default ContractorsShowroom;
